import { createSlice } from "@reduxjs/toolkit";

export const addToCartSlice = createSlice({
  name: "addToCart",
  initialState: {
    isPostLoading: false,
    addToCartData: [],
    postMessage: "",
  },
  reducers: {
    onPostAddToCart: (state) => {
      return {
        ...state,
        isPostLoading: true,
        addToCartData: [],
        postMessage: "",
      };
    },
    onPostAddToCartSuccess: (state, { payload }) => {
      const { postData = [], message = "", status_code = ""} = payload;
      return {
        ...state,
        isPostLoading: false,
        addToCartData: postData,
        postMessage: message,
        post_status_code: status_code,
      };
    },

    onPostAddToCartError: (state, { payload }) => {
      const { data = [], message = "", status_code = "" } = payload;

      return {
        ...state,
        addToCartData: data,
        postMessage: message,
        post_status_code: status_code,
        isPostLoading: false,
      };
    },
    onPostAddToCartReset: (state) => {
      return {
        ...state,
        isPostLoading: false,
        addToCartData: [],
        postMessage: "",
        post_status_code: null,
      };
    },
  },
});
export const {
  onPostAddToCart,
  onPostAddToCartSuccess,
  onPostAddToCartError,
  onPostAddToCartReset,
} = addToCartSlice.actions;

export default addToCartSlice.reducer;
